export default "__VITE_ASSET__D2w2c4ya__"